import { initAuth0, loginToAdmin } from "./admin/services/auth.mjs";

const auth = await initAuth0();

if (!(await auth.isAuthenticated())) {
    const statusEl = document.getElementById("login-status");
    if (statusEl) {
        statusEl.innerText = "Please login to access this page.";
    }
}
document.getElementById("btn-login")?.addEventListener("click", async () => {
    await loginToAdmin();
});

const isSalePage = window.location.pathname.startsWith("/sale/");

if (await auth.isAuthenticated() && !isSalePage) {
    window.location.replace("/admin.html");
}
